import { render, staticRenderFns } from "./applicationUsersApprovalForms.vue?vue&type=template&id=545bfe71&scoped=true"
import script from "./applicationUsersApprovalForms.vue?vue&type=script&lang=js"
export * from "./applicationUsersApprovalForms.vue?vue&type=script&lang=js"
import style0 from "./applicationUsersApprovalForms.vue?vue&type=style&index=0&id=545bfe71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545bfe71",
  null
  
)

export default component.exports